import { PsvProviderStatus } from "@api/shared-runtime/psv-review";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import type { ItemSummary } from "@/features/credentials/components/primary-source-runs/types";
import { formatRunDate } from "../../format-run-time";
import {
  psvStatusLabel,
  psvStatusTextClassName,
  type PsvStatus,
} from "../../workspace-psv-presentation";

function Cell({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className="space-y-1 px-4 py-3 first:pl-0">
      <dt className="text-xs text-muted-foreground">{label}</dt>
      <dd className="text-sm font-semibold">{children}</dd>
    </div>
  );
}

/** Where the provider's verification stands, in four facts. */
export function SummaryStrip({
  psv,
  itemSummary,
}: {
  psv: PsvStatus;
  itemSummary?: ItemSummary;
}) {
  const active = psv.status === PsvProviderStatus.InProgress;
  return (
    <dl className="grid grid-cols-2 border-y py-1 md:grid-cols-4 md:divide-x">
      <Cell label="Verification status">
        <span className={cn(psvStatusTextClassName(psv.status))}>
          {psvStatusLabel(psv)}
        </span>
      </Cell>
      <Cell label="Last completed on">
        {formatRunDate(psv.lastCompletedAt)}
      </Cell>
      <Cell label="Latest attempted run">{formatRunDate(psv.latestRunAt)}</Cell>
      {active ? (
        <Cell label="Checks finished">
          {psv.finishedChecks} of {psv.totalChecks}
        </Cell>
      ) : (
        <Cell label="Items reviewed">
          {itemSummary
            ? `${itemSummary.accepted + itemSummary.concern} of ${itemSummary.total}`
            : "—"}
        </Cell>
      )}
    </dl>
  );
}
